import { render } from "./NumberEditor.vue?vue&type=template&id=f57506b8&scoped=true"
import script from "./NumberEditor.vue?vue&type=script&lang=js"
export * from "./NumberEditor.vue?vue&type=script&lang=js"

import "./NumberEditor.vue?vue&type=style&index=0&id=f57506b8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57506b8"]])

export default __exports__